import { render, staticRenderFns } from "./CmgLeaderboardBadges.vue?vue&type=template&id=34a85837&scoped=true&lang=pug"
import script from "./cmg-leaderboard-badges.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-badges.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardBadges.vue?vue&type=style&index=0&id=34a85837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a85837",
  null
  
)

export default component.exports